import _ from 'lodash';
export var isEmbedEnabled = function (_a) {
    var videoItem = _a.videoItem, channelData = _a.channelData;
    return channelData.premiumOwner &&
        _.get(videoItem, 'embedOptions.enabled') !== false;
};
